import { createSelector } from 'reselect'

// const stateSelector = state => state
const teamCalendarSelector = state => state.get('teamCalendar')

export const getTeamCalendar = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.teamCalendar
  }
)

export const getIsFetching = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.isFetching
  }
)

export const getOpenedItems = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.openedItems
  }
)

export const getMoment = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.moment
  }
)

export const getRange = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.range
  }
)

export const getSearch = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.search
  }
)

export const getTab = createSelector(
  teamCalendarSelector,
  teamCalendarImmutable => {
    const teamCalendar = teamCalendarImmutable.toJS()
    return teamCalendar.teamCalendar.tab
  }
)



// WEBPACK FOOTER //
// ./src/selectors/team-calendar/team-calendar-selector.js